export enum NotEligibleError {
  CODE = 'Routing-101',
  MESSAGE = 'The Service Line Queue is not eligible for routing due to its status.',
}
